import { FC } from 'react';
import { Box, useTheme } from '@mui/material';
import { FragmentType, getFragmentData, graphql } from '../gql';
import { Avatar } from '../components/Avatar';

const personaFragment = graphql(`
	fragment PersonaAvatar_persona on Persona {
		name
		avatar {
			url90: url(width: 90, height: 90)
			url48: url(width: 48, height: 48)
			url40: url(width: 40, height: 40)
			url24: url(width: 24, height: 24)
		}
	}
`);

type PersonaFragment = FragmentType<typeof personaFragment>;

type Props = {
	readonly persona: PersonaFragment;
};

type PropsLarge = Props & {
	readonly color?: string | null;
	readonly withBorder?: boolean;
};

const PersonaAvatarLarge: FC<PropsLarge> = ({ persona, withBorder, color }) => {
	const theme = useTheme();

	const personaData = getFragmentData(personaFragment, persona);

	return (
		<Box
			sx={
				withBorder
					? {
							border: `2px solid ${color || theme.palette.error.main}`,
							borderRadius: '50%',
							padding: '5px',
						}
					: {}
			}
		>
			<Avatar src={personaData.avatar?.url90 ?? undefined} alt={personaData.name} sx={{ width: 90, height: 90 }} />
		</Box>
	);
};

const PersonaAvatar: FC<Props> = ({ persona }) => {
	const data = getFragmentData(personaFragment, persona);
	return <Avatar src={data.avatar?.url40 ?? undefined} alt={data.name} />;
};

const PersonaAvatarSmall: FC<Props> = ({ persona }) => {
	const data = getFragmentData(personaFragment, persona);
	return <Avatar src={data.avatar?.url24 ?? undefined} alt={data.name} sx={{ width: 24, height: 24 }} />;
};

export { PersonaAvatar, PersonaAvatarSmall, PersonaAvatarLarge };
